import Account from '@/lib/account'
import * as Constants from '@/lib/constants'
import ApplicationConfig from '@/lib/application-config'
import UserInfo from '@/lib/user-info'
import DateUtilities from '@/lib/date-utilities'
import { Functionality } from '@/lib/user-info'
import FieldNameMixin from '@/components/mixins/field-name-mixin'
import i18n from '@/lib/i18n'

export default {
  mixins: [FieldNameMixin],
  data() {
    return {
      isMobile: false,
    }
  },

  created() {
    this.$store.dispatch('getAllFields')
  },

  methods: {
    onResize() {
      if (window.innerWidth < Constants.RESPONSIVE_BREAKPOINT_TASK_LIST) this.isMobile = true
      else this.isMobile = false
    },

    getAccount(task) {
      return Account.getByTask(task)
    },

    showDetail(task) {
      this.openNowLoading()
      this.$store.dispatch('getAllFields')
      const params = {
        task: task,
        nextPageName: 'TaskDetail',
        taskDetailShowAction: Constants.SHOW_TASK_DETAIL_FROM_LIST,
      }
      this.$store.dispatch('showTaskDetail2', params)
    },
    closeNowLoading() {
      this.$parent.nowLoading = false
    },
    openNowLoading() {
      this.$parentnowLoading = true
    },
    hasFreeFunctionality(userInfo) {
      return userInfo.functionality === Functionality.AS_FREE
    },

    hidden(task) {
      const userInfo = this.subscribingUserInfos.find(sui => sui.username === task.username)
      if (typeof userInfo === 'undefined') {
        return false
      }
      if (this.hasFreeFunctionality(userInfo)) {
        if (Date.parse(task.startTime) < this.dateTwoDaysAgo.getTime()) {
          return true
        }
      }
      return false
    },

    isStandardNotAvailable() {
      const standardAvailable = UserInfo.hasStandardFunctionality()
      return !standardAvailable
    },

    toBilling() {
      this.$router.push({ name: 'BillingBilling' })
    },
    getFieldNameFromFieldGeoInfoKeyFromTask(task) {
      if (UserInfo.isFSMigrated()) {
        if (!task.fieldName) {
          return i18n.tt('customFieldNoName')
        }
        return task.fieldName
      } else {
        return this.getFieldNameFromFieldGeoInfoKey(task.fieldItemKey)
      }
    },
  },

  computed: {
    dateFilterRange() {
      return this.$store.getters.dateFilterRange
    },
    filterDateFrom() {
      return this.$store.getters.filterDateFrom
    },
    filterDateTo() {
      return this.$store.getters.filterDateTo
    },
    selectPickerType() {
      return this.$store.getters.selectPickerType
    },
    tasks() {
      return this.$store.getters.tasks
    },
    fields() {
      return this.$store.getters.fields
    },
    products() {
      return this.$store.getters.products
    },
    subscribingUserInfos() {
      return this.$store.getters.subscribingUserInfos
    },
    dateTwoDaysAgo() {
      return DateUtilities.getDateTwoDaysAgo()
    },
  },

  watch: {},
}
